<template>
    <div class="w-full border-y md:py-2 py-1">
        <div v-for="subject in field.value" :key="subject.subject_type + subject.subject_id" class="mb-4">

            <!-- subject label -->
            <div class="subject-label">{{ subject.subject_label }}</div>

            <div class="pd-wrap">
                <div class="pd-header">
                    <div class="pd-header-cell">فیلد</div>
                    <div v-if="!isCreate(subject)" class="pd-header-cell">مقدار قبلی</div>
                    <div class="pd-header-cell">مقدار جدید</div>
                </div>

                <div
                    v-for="item in subject.fields"
                    :key="item.key"
                    :class="['pd-row', { changed: isChanged(item) }]"
                >
                    <div class="pd-label">{{ item.label }}</div>

                    <div v-if="!isCreate(subject)" class="pd-old">
                        <template v-if="item.type === 'image'">
                            <img v-if="item.original.simulateValue" :src="item.original.simulateValue" class="thumb" @click="lightbox = item.original.simulateValue" />
                            <span v-else class="empty">—</span>
                        </template>
                        <ApprovalVideoPreview
                            v-else-if="item.type === 'video'"
                            :url="item.original.simulateValue"
                        />
                        <span v-else>{{ item.original.simulateValue ?? '—' }}</span>
                    </div>

                    <div class="pd-new">
                        <template v-if="item.type === 'image'">
                            <img v-if="item.new.simulateValue" :src="item.new.simulateValue" class="thumb cursor-pointer" @click="lightbox = item.new.simulateValue" />
                            <span v-else class="empty">—</span>
                        </template>
                        <ApprovalVideoPreview
                            v-else-if="item.type === 'video'"
                            :url="item.new.simulateValue"
                        />
                        <span v-else>{{ item.new.simulateValue ?? '—' }}</span>
                        <span v-if="isChanged(item)" class="badge-changed">تغییر</span>
                    </div>
                </div>
            </div>

        </div>

        <!-- lightbox -->
        <div v-if="lightbox" class="lightbox-overlay" @click="lightbox = null">
            <img :src="lightbox" class="lightbox-img" />
        </div>
    </div>
</template>

<script>
import ApprovalVideoPreview from '../../components/ApprovalVideoPreview.vue'

export default {
    components: { ApprovalVideoPreview },

    data: () => ({
        lightbox: null,
    }),

    props: ['field', 'resource', 'resourceName', 'resourceId'],

    methods: {
        isCreate(subject) {

            if(this.field.isCreate) {
                return true
            }

            return subject.fields.every(item => item.original.value === null);
        },

        isChanged(item) {
            if (item.original.value === null) return false;
            return item.original.value !== item.new.value;
        },
    }
};
</script>

<style scoped>

.subject-label {
    font-size: 12px;
    font-weight: 500;
    color: rgba(var(--colors-gray-500), 1);
    padding: 0 4px 6px;
}

.pd-wrap {
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(var(--colors-gray-200), 1);
}

.pd-header {
    display: grid;
    grid-template-columns: 180px 1fr 1fr;
    background: rgba(var(--colors-gray-100), 1);
}
.pd-header-cell {
    padding: 9px 14px;
    font-size: 12px;
    font-weight: 500;
    color: rgba(var(--colors-gray-500), 1);
    border-bottom: 1px solid rgba(var(--colors-gray-200), 1);
}
.pd-header-cell:not(:last-child) {
    border-right: 1px solid rgba(var(--colors-gray-200), 1);
}

.pd-row {
    display: grid;
    grid-template-columns: 180px 1fr 1fr;
    border-bottom: 1px solid rgba(var(--colors-gray-200), 1);
}
.pd-row:last-child { border-bottom: none; }
.pd-row.changed { background: rgba(var(--colors-yellow-50), 0.5); }

/* ستون فیلد — آبی */
.pd-label {
    padding: 10px 14px;
    font-size: 13px;
    font-weight: 500;
    color: rgba(var(--colors-primary-600), 1);
    background: rgba(var(--colors-primary-50), 1);
    border-right: 1px solid rgba(var(--colors-gray-200), 1);
    display: flex;
    align-items: center;
}

/* ستون قبلی — قرمز ملایم */
.pd-old {
    padding: 10px 14px;
    font-size: 13px;
    color: rgba(var(--colors-gray-400), 1);
    border-right: 1px solid rgba(var(--colors-gray-200), 1);
    display: flex;
    align-items: center;
    background: rgba(var(--colors-red-50), 0.4);
}

/* ستون جدید */
.pd-new {
    padding: 10px 14px;
    font-size: 13px;
    color: rgba(var(--colors-gray-700), 1);
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.thumb {
    height: 36px;
    border-radius: 4px;
    border: 1px solid rgba(var(--colors-gray-200), 1);
    transition: opacity 0.15s;
}
.thumb:hover { opacity: 0.75; }

.lightbox-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.4); /* از 0.75 به 0.4 */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: zoom-out;
}
.lightbox-img {
    max-width: 90vw;
    max-height: 85vh;
    border-radius: 8px;
    object-fit: contain;
}
.empty { color: rgba(var(--colors-gray-400), 1); }

.badge-changed {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 5px;
    font-weight: 500;
    background: rgba(var(--colors-yellow-100), 1);
    color: rgba(var(--colors-yellow-800), 1);
}

/* حالت تاریک: مرزهای مشخص‌تر (مش)، پس‌زمینهٔ سلول‌ها و متن خوانا */

html.dark .pd-wrap,
.dark .pd-wrap {
    border-color: rgba(var(--colors-gray-600), 1);
    background: rgba(var(--colors-gray-900), 1);
}

html.dark .pd-header,
.dark .pd-header {
    background: rgba(var(--colors-gray-800), 1);
}

html.dark .pd-header-cell,
.dark .pd-header-cell {
    border-color: rgba(var(--colors-gray-600), 1);
    color: rgba(var(--colors-gray-300), 1);
}

html.dark .pd-header-cell:not(:last-child),
.dark .pd-header-cell:not(:last-child) {
    border-right-color: rgba(var(--colors-gray-600), 1);
}

html.dark .pd-row,
.dark .pd-row {
    border-color: rgba(var(--colors-gray-600), 1);
    background: rgba(var(--colors-gray-900), 1);
}

html.dark .pd-row.changed,
.dark .pd-row.changed {
    background: rgba(var(--colors-yellow-950), 0.45);
}

html.dark .pd-label,
.dark .pd-label {
    background: rgba(var(--colors-primary-900), 0.45);
    color: rgba(var(--colors-primary-300), 1);
    border-color: rgba(var(--colors-gray-600), 1);
}

html.dark .pd-old,
.dark .pd-old {
    background: rgba(var(--colors-red-950), 0.35);
    color: rgba(var(--colors-gray-200), 1);
    border-color: rgba(var(--colors-gray-600), 1);
}

html.dark .pd-new,
.dark .pd-new {
    background: rgba(var(--colors-gray-950), 1);
    color: rgba(var(--colors-gray-100), 1);
}

html.dark .pd-new span,
.dark .pd-new span {
    color: inherit;
}

html.dark .pd-new .empty,
.dark .pd-new .empty {
    color: rgba(var(--colors-gray-500), 1);
}

html.dark .thumb,
.dark .thumb {
    border-color: rgba(var(--colors-gray-600), 1);
}

html.dark .badge-changed,
.dark .badge-changed {
    background: rgba(var(--colors-yellow-900), 1);
    color: rgba(var(--colors-yellow-200), 1);
}

html.dark .subject-label,
.dark .subject-label {
    color: rgba(var(--colors-gray-400), 1);
}

html.dark .video-link,
.dark .video-link {
    color: rgba(var(--colors-primary-300), 1);
}

</style>
